module.exports = __webpack_public_path__ + "img/Group 106.8f92c636.jpg";